module.exports = __webpack_public_path__ + "img/whatsapp-icon.0a8a2fcf.png";